import React from "react";
// import {ButtonGroup,Button,Dropdown} from 'react-bootstrap';
import "./css/DropDownLanguage.css";
function DropDownLanguage() {
  return (
    <>
      <div>
        <select className="custom-select">
          <option value="0" style={{ color: "white" }}>
            Language
          </option>
          <option value="1">English</option>
          <option value="2">Hindi</option>
          <option value="3">Bangla</option>
        </select>
      </div>
    </>
  );
}

export default DropDownLanguage;
